import type { LabData } from '../AppData/LabData';

const MODEL_VIEWER_MODEL_ID_PATTERN = /^[a-zA-Z0-9_-]{1,128}$/;

export const isModelViewerModelId = (value:unknown):value is string => (
    typeof value === 'string' && MODEL_VIEWER_MODEL_ID_PATTERN.test(value)
);

export const getModelViewerModelIds = (
    labData:LabData|undefined,
    variant:string,
):string[] => (
    Object.keys(labData?.variants[variant]?.models ?? {})
);

/**
 * Resolve a product-variant model synchronously. Explicit preview data wins,
 * the owning interactive viewer's selection is the fallback, and JSON
 * insertion order remains the default used by the existing viewer.
 */
export const resolveModelViewerModelId = (
    labData:LabData,
    variant:string,
    requestedModel?:string,
    fallbackModel?:string,
):string|undefined => {
    const modelIds = getModelViewerModelIds(labData, variant);

    if(requestedModel && modelIds.includes(requestedModel)) {
        return requestedModel;
    }
    if(fallbackModel && modelIds.includes(fallbackModel)) {
        return fallbackModel;
    }
    return modelIds[0];
};

export const isModelViewerModelAvailable = (
    labData:LabData|undefined,
    variant:string,
    model:string|undefined,
):boolean => (
    model === undefined
    || getModelViewerModelIds(labData, variant).includes(model)
);
